import { getCurrentClinic } from '@/utils/localStorageManager'

const unities = state => () => {
  return state.clinics.filter(unity => unity.root_clinic_id)
}

const unitySelectOptions = state => {
  const options = state.clinics
    .filter(unity => unity.root_clinic_id)
    .map(unity => ({
      value: unity.id,
      text: unity.name
    }))

  options.unshift({
    value: null,
    text: 'Selecione uma unidade'
  })

  return options
}

const unitiesSelectOptions = state => {
  const clinic = getCurrentClinic()
  const rootClinicId = clinic.root_clinic_id || clinic.id
  return state.clinics
    .filter(
      unity =>
        unity.id === rootClinicId || unity.root_clinic_id === rootClinicId
    )
    .map(unity => ({
      value: unity.id,
      text: unity.name
    }))
}

export default {
  unities,
  unitySelectOptions,
  unitiesSelectOptions
}
